import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as form } from 'redux-form';

import auth from './auth';
import featureFlags from './featureFlags';
import unleashFeatureFlagsReducer from './featureFlags/unleash';
import forgotPassword from './forgotPassword';
import login from './login';
import moka from './moka';
import notification from './notifications';
import openPlatform from './openPlatform';
import registerForm from './register';
import verifyEmail from './verifyEmail';

const reducer = combineReducers({
  auth,
  featureFlags,
  unleashFeatureFlags: unleashFeatureFlagsReducer,
  forgotPassword,
  form,
  login,
  moka,
  notification,
  openPlatform,
  registerForm,
  routing: routerReducer,
  verifyEmail,
});

export default reducer;
